import { _t } from 'app/utils/i18n';
import * as Yup from 'yup';

export const emailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .email(_t('basic:wrong_email'))
    .required(_t('basic:This_field_is_mandatory'))
    .typeError(_t('basic:wrong_email')),
});

export const passwordsValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required(_t('users:passwordـisـrequired'))
    .matches(/(.*\d)(.*[A-Za-z])|(.*[A-Za-z])(.*\d){1,}|^$/, () => undefined)
    .matches(
      /(.*[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]){1,}|^$/,
      () => undefined
    )
    .matches(/(.*[a-z])(.*[A-Z])|(.*[A-Z])(.*[a-z]){1,}|^$/, () => undefined)
    .matches(/(.{8,}|^)$/, _t('users:Password_is_too_short')),
  confirm_password: Yup.string().oneOf(
    [Yup.ref('password'), undefined],
    _t('users:Passwords_must_match')
  ),
});

export const codeValidationSchema = Yup.object().shape({
  second_auth_code: Yup.string()
    .trim()
    .required(_t('basic:This_field_is_mandatory')),
});
